import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3mzwb88s7h: FaireBrandEntity = {
  token: "b_3mzwb88s7h",
  type: "brand",
  name: "Waxing Moon",
  avatarUrl:
    "https://cdn.faire.com/fastly/8a52661ae974bec7aee744ea04c19c7ca33f523de7ff204a812c0f1cf5624214.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/306ea77581ecc3a2b3a4788e30e35d7037ad27554e27045a35a2b7c283d06d4b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8a52661ae974bec7aee744ea04c19c7ca33f523de7ff204a812c0f1cf5624214.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/306ea77581ecc3a2b3a4788e30e35d7037ad27554e27045a35a2b7c283d06d4b.jpeg",
  location: "Missoula, MT, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 16,
  isTopShop: true,
  isInsider: true,
  description:
    "WAXING MOON IS A BEESWAX CANDLE STUDIO SPECIALIZING IN HAND-DIPPED TAPERS AND MOLDED CANLDES. BEHIND EVERY CANDLE IS THE INTENTION AND DESIRE TO CREATED A SUSTAINABLE PRODUCT FOR A MULTITUDE OF OCCASIONS AND TO ELEVATE THE EVERY DAY. \n\nA COMPANY CONSISTING OF ONE WOMAN WHO’S CHRONICALLY PASSIONATE SO ALWAYS DISCOVERING AND ADDING TO THE COLLECTIONS WHILE MAINTAINING A METICULOUS NATURE AND COMMITTED TO THE FINEST DETAIL. THIS IS A MICRO BUSINESS IN THE PROCESS OF BUILDING OUR COLLECTIONS AND GROWING THE COMPANY.\n\nFOR OUR FULL COLLECTIONS AND ANSWERS TO WHOLESALE QUESTIONS VISIT OUR WEBSITE. WAXINGMOON.CO/WHOLESALE\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:20.554Z",
    importedBy: "entity-db-cli",
  },
};
